import { IAction } from "../utils";
import { reducerTypes } from "./types";

export const INITIAL: boolean = false;

export const loadingReducer = (state = INITIAL, { type }: IAction) => {
  switch (type) {
    case reducerTypes.TOGGLE_LOADING:
      return !state;
    default:
      return state;
  }
};
